export class EventsConstants {
    public static PRODUCTS_LOADED_EVENT = 'productsLoaded';
    public static PRODUCT_DELETE_EVENT = 'deleteProduct';
    public static PRODUCT_UPDATE_EVENT = 'updateProduct';
    public static PRODUCT_ADD_EVENT = 'addProduct';

}
